import { Button, Grid } from "@mui/material";
import ImagesUploaderForm from "../ImagesUploaderForm/ImagesUploaderForm";
import DialogService from "../Dialog/dialogService";
import ProfileImg from "../ProfileImg/ProfileImg";

interface ProfileImgFormProps {
  imgUrl: string | undefined;
  size?: number;
  setValue?: Function;
}

export default function ProfileImgForm({
  imgUrl,
  size,
  setValue,
}: ProfileImgFormProps) {
  const { openXS } = DialogService();

  const openModal = () => {
    if (setValue) {
      openXS(
        "Change Profile Image",
        <ImagesUploaderForm defaultName={"profile"} addImage={setValue} />,
        []
      );
    }
  };

  return (
    <Grid
      item
      container
      direction="row"
      columnSpacing={2}
      alignItems={"center"}
    >
      <Grid item>
        <ProfileImg
          imgUrl={imgUrl}
          size={size}
          square={true}
          hideShadow={true}
        />
      </Grid>
      <Grid item>
        <Button
          variant={"customBlueTextUnderLine"}
          sx={{
            textDecorationThickness: "2px",
            textUnderlineOffset: "5px",
            fontWeight: "500 !important",
          }}
          onClick={openModal}
        >
          Change Image
        </Button>
      </Grid>
    </Grid>
  );
}
